import Cookies from "js-cookie";

import { logError } from "../components/Errors";
import { getUser, getClient } from "./session";

const ACCESS_TOKEN_ERROR = "Access token could not be found.";

export const accessToken = ({ feature, cookies }) => ({ cookies, feature });

export const setAccessToken = ({ cookies, token, expires }) =>
  cookies.set("ACCESS_TOKEN", token, { path: "/", expires });

export function getAccessToken() {
  return Cookies.get("ACCESS_TOKEN");
}

export function getRefreshToken() {
  return Cookies.get("REFRESH_TOKEN");
}

export function getProfileUuid() {
  return Cookies.get("USER_PROFILE_ID");
}

function getAccessTokenFromCookies(cookies) {
  return cookies.get("ACCESS_TOKEN");
}

export const getAccessTokenForFeature = ({ cookies, feature }) => {
  const accessToken = getAccessTokenFromCookies(cookies);
  const isValid = typeof accessToken !== "undefined";
  !isValid && notifyBugsnagAccessTokenError(feature);
  return accessToken;
};

export const notifyBugsnagAccessTokenError = (feature) =>
  logError({
    client: getClient.client_uuid,
    feature,
    message: ACCESS_TOKEN_ERROR,
    user: {
      id: getUser.user_uuid,
      name: `${getUser.first_name} ${getUser.last_name}`,
    },
  });
